import type { PriceTagV2Price } from '@synoptic/ui-kit/price-tag-v2/price-tag-v2.js';
import type { StreamPackageCardFragmentFragment } from '@/__generated__/graphql.ts';
import { convertCentsToDollars } from '@/utils/convert-cents-to-dollars.ts';
import { getMonthlyPrice } from '@/utils/paid-data.ts';

type StreamPackagePricing = {
  packagePaidData:
    | StreamPackageCardFragmentFragment['packagePaidData']
    | null
    | undefined;
};

const formatDollars = (cents: number): string => {
  const dollars = convertCentsToDollars(cents);
  return Number.isInteger(dollars) ? String(dollars) : dollars.toFixed(2);
};

export const streamPackagePriceV2 = (
  streamPackage: StreamPackagePricing,
): PriceTagV2Price => {
  const monthly = getMonthlyPrice(streamPackage.packagePaidData);
  if (monthly == null || monthly === 0) {
    return 'free';
  }

  return { per: 'month', amount: formatDollars(monthly) };
};
